import { useEffect } from 'react';

const useSocket = (socket, isAuthenticated, updateChats, handleError) => {
  useEffect(() => {
    if (isAuthenticated) {
      const handleMessage = (message) => {
        updateChats(message);
      };

      const handleErrorFinalizandoChat = (errorData) => {
        handleError(errorData);
      };

      socket.on('new_message', handleMessage);
      socket.on('new_chat', handleMessage);
      socket.on('update_chat', handleMessage);
      socket.on('error_finalizando_chat', handleErrorFinalizandoChat); // Escuta o evento de erro

      return () => {
        socket.off('new_message', handleMessage);
        socket.off('new_chat', handleMessage);
        socket.off('update_chat', handleMessage);
        socket.off('error_finalizando_chat', handleErrorFinalizandoChat); // Remover listener
      };
    }
  }, [isAuthenticated, socket, updateChats, handleError]);
};

export default useSocket;
